import async from "async";
import * as AdminService from '../services/adminService';
import * as WebService from '../services/webService';
import {receivePanelDraft, receivePanelNotifications} from "../actions/panelAction";

export const panelDraftServices = (dispatch,params) => {
    return new Promise((resolve, failure) => {
        async.series([
            (cb) => {
                AdminService.getDrafts(params).then((res) => {
                    if (res.data.success) {
                        cb(null, res.data.success);
                    }
                })
                    .catch((err) => {

                    })
            },
            (cb) => {
                WebService.getPanelNotifications(params).then((res) => {
                    if (res.data.success) {
                        cb(null, res.data.success);
                    }
                })
                    .catch((err) => {
                        cb(null,null)
                    })
            }
        ], (err, result) => {
            dispatch(receivePanelDraft(result[0],true));
            dispatch(receivePanelNotifications(result[1]));
            resolve(result);
        });
    });


};
